import React, { useCallback } from 'react'
import { AppSvg, ButtonVertical, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import { lang } from './lang'

interface Props {
    card?: GetCard
    isDisabled?: boolean
    topUp: boolean
    setTopUp: (isOpen: boolean) => void
}

function TopUp({ isDisabled, setTopUp }: Props) {
    const onOpen = useCallback(() => {
        setTopUp(true)
    }, [setTopUp])

    return (
        <>
            <ButtonVertical
                dataPointer="top_up"
                label={<FormattedHTMLMessage {...lang.topUp} />}
                role="button"
                icon={<AppSvg svgName={newIcons.ic24Plus} path="new-icons" size={24} />}
                onClick={onOpen}
                isDisabled={isDisabled}
            />
        </>
    )
}

export default TopUp
